// extracted by mini-css-extract-plugin
export default {"container":"style_container__cxnu4","iconContainer":"style_iconContainer__QgTLK","icon":"style_icon__21mnH","textContainer":"style_textContainer__LQjaY"};